"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByKey = void 0;
const get_1 = require("./get");
const alphabeticalSort_1 = require("./alphabeticalSort");
// sorts an array of objects by giving an object key
// … called with […].sort(sortByKey('id'))
// … called with […].sort(sortByKey('id', -1)) to get the reverse
/* eslint-disable @typescript-eslint/no-explicit-any */
const sortByKey = (key, order = 1) => {
    return (a, b) => (0, alphabeticalSort_1.alphabeticalSort)((0, get_1.get)(a, key), (0, get_1.get)(b, key)) * order;
};
exports.sortByKey = sortByKey;
/* eslint-enable @typescript-eslint/no-explicit-any */
//# sourceMappingURL=sortByKey.js.map